import { wpFetchRestApi, isWpSuccess } from "../util";
export async function cancelMeeting(meeting, reason) {
    const endpoint = 'meeting/' + meeting.id + '/cancel';
    const result = await wpFetchRestApi(endpoint, 'PATCH', { reason });
    if (isWpSuccess(result)) {
        return result.data;
    }
    throw new Error(result.message);
}
